export const MSGTYPE_VAT_TH = Symbol('th-vat');
export const MSGTYPE_VAT_KR = Symbol('kr-vat');
export const MSGTYPE_VAT_SG = Symbol('sg-vat');

export const BannerColorConfig = {
  red: '#D83E0E',
  orange: '#E0A111',
  blue: '#3451F7',
};

export const BannerCtaAction = { // 兜底action
  closeNoti: 'closeNoti',
};
